import angular from "angular";
import {SHARE_ITEM_TYPE} from "@common/share/components/shareItem/share-item.directive";
import {CacheService} from "@common/service/cache.service";

export class SkipSharingController {
    enterpriseDoc = false;
    message = "";
    avoidDlg = false;
    msg = "";
    messages = {
        document: {
            var1: "Document",
            var2: "uploaded"
        },
        discussion: {
            var1: "Discussion",
            var2: "started"
        }
    }
    static $inject = ["$uibModalInstance", "$sce", "CacheService", "displayAs"];

    constructor(private $uibModalInstance : angular.ui.bootstrap.IModalInstanceService, $sce, $_cache : CacheService, displayAs : string) {
        var obj = this.messages[displayAs];
        this.enterpriseDoc = (displayAs == SHARE_ITEM_TYPE.DOCUMENT && $_cache.getUser().organizationId > 0);
        if (this.enterpriseDoc) {
            this.msg = `Only you and members of your Care Org on this Team will have access. You can always share it later by clicking the ${obj.var1}'s <span class="share-button"><i class="econ-add-thick"></i></span> button or click <b>Go Back</b> to share now.`;
        } else {
            this.msg = `Only you will have access to this ${obj.var1} after it is ${obj.var2}. You can always share it later by clicking the ${obj.var1}'s <span class="share-button"><i class="econ-add-thick"></i></span> button or click <b>Go Back & Share</b> to share now.`
        }
        this.message = $sce.trustAsHtml(this.msg);
    }

    close = (): void => {
        this.$uibModalInstance.close(this.avoidDlg);
    }

    cancel = (): void => {
        this.$uibModalInstance.dismiss();
    }
}

angular.module('eCareVault.common.share')
    .controller('SkipSharingController', SkipSharingController);
